<div class="position-relative">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>


  <div class="panel-title"> {{alertRuleAdd ? 'Add' : alertRuleEdit ? 'Edit' : 'View'}} {{pageType !== 'alertProfile' ? (isShown === 'site' ? ('plant'
    | translate) : isShown === 'tenant' ? ('client' | translate) : 'Global'): ''}} {{pageType === 'alertProfile' ? 'Alert Profile': 'Alert Rule'}} </div>
  <form [formGroup]="alertRuleForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="mt-top-2 my-4">
      <!-- <mat-form-field class="field">
            <mat-label>Active</mat-label>
            <mat-select  [disableOptionCentering]="true" formControlName="active">
               <mat-option [value]="true" >True</mat-option>
                <mat-option [value]="false" >False</mat-option>
            </mat-select>
        </mat-form-field> -->

      <mat-slide-toggle formControlName="active" (change)="activeChange($event)"></mat-slide-toggle>
      <span class="slider round"></span>
      <mat-label>Active</mat-label>
    </div>
    <div class="mt-top-2 field -mat-select-arrow-mt-22">
      <mat-form-field *ngIf="(!alertRuleEdit && !alertRuleView) && (isShown === 'site')" class="field">
        <mat-label>Select {{'plant' | translate}}</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="siteId">
          <mat-option *ngFor="let item of siteList" [value]="item._id" (onSelectionChange)="getAlertList($event)">
            {{item.name | titlecase}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mt-top-2 field -mat-select-arrow-mt-22"
      *ngIf="(!alertRuleEdit && !alertRuleView) && (isShown === 'site' ||  isShown === 'tenant')">
      <mat-form-field class="field">
        <mat-label>Select Alert Id</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="alertId" (selectionChange)="onSelectEvent($event)">
          <mat-option *ngFor="let item of alertListForTenant" [value]="item['alertId']">{{item['alertId']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="make-responsive alert-field -mat-select-arrow-mt-22" *ngIf="alertValue">
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Alert Id</mat-label>
          <input matInput [readonly]="true" formControlName="alertId">
          <ng-container *ngIf="formSubmitted && formValues['alertId'].errors">
            <mat-error *ngIf="formValues['alertId'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>AlertId is required
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>{{pageType === 'alertProfile' ? 'Alert Title' : 'Alert Description' }}</mat-label>
          <input matInput formControlName="alertDesc">
          <ng-container *ngIf="formSubmitted && formValues['alertDesc'].errors">
            <mat-error *ngIf="formValues['alertDesc'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Alert Description is required
            </mat-error>
            <mat-error *ngIf="formValues['alertDesc'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="pageType !== 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Alert Type</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="class">
            <mat-option *ngFor="let item of classType" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="modal-form d-flex" *ngIf="isShown === 'global' && pageType !== 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Select Scope</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="type">
            <mat-option *ngFor="let item of scope" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>{{pageType === 'alertProfile' ? 'Severity' : 'Select Severity' }}</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="alertSeverity">
            <mat-option *ngFor="let item of alertSeveritydd; let i = index" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="pageType === 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Message</mat-label>
          <input matInput formControlName="message">
          <ng-container *ngIf="formSubmitted && formValues['message'].errors">
            <mat-error *ngIf="formValues['message'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Message is required
            </mat-error>
            <mat-error *ngIf="formValues['message'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="pageType !== 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Select Action</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="action">
            <mat-option *ngFor="let item of alertActionsdd; let i = index" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="pageType !== 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Select Category</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="alertCategory">
            <mat-option *ngFor="let item of alertCategorydd; let i = index" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="pageType !== 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Select Category Nature</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="categoryNature">
            <mat-option *ngFor="let item of alertCategoryNaturedd; let i = index" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="pageType !== 'alertProfile'">
        <mat-form-field class="field">
          <mat-label>Excluded Zone Risk Type</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="excludedZoneRiskTypes">
            <mat-option *ngFor="let item of zoneRiskTypeList; let i = index" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!-- <div class="d-flex align-items-center" *ngIf="alertValue"><span class="mr-2 sub-title">Turn on
                Notifications</span>
            
        </div> -->
    <div class="make-responsive toggle-box-style" *ngIf="alertValue">

      <div class="mt-top-2" *ngIf="pageType !== 'alertProfile'">
        <!-- <mat-form-field class="field">
                    <mat-label>SMS</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="sms">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field> -->

        <mat-slide-toggle formControlName="sms" (change)="smsChange($event)"></mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>SMS</mat-label>
      </div>
      <div class="mt-top-2" *ngIf="pageType !== 'alertProfile'">
        <!-- <mat-form-field class="field">
                    <mat-label>Email</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="email">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field> -->

        <mat-slide-toggle formControlName="email" (change)="emailChange($event)"></mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>Email</mat-label>
      </div>
      <div class="mt-top-2" *ngIf="pageType !== 'alertProfile'">
        <!-- <mat-form-field class="field">
                    <mat-label>C2D</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="c2d">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field> -->

        <mat-slide-toggle formControlName="c2d" (change)="c2dChange($event)"></mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>C2D</mat-label>
      </div>
      <div class="mt-top-2">
        <!-- <mat-form-field class="field">
                    <mat-label>Web Notification</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="webNotification">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field> -->

        <mat-slide-toggle formControlName="webNotification" (change)="webNotificationChange($event)">
        </mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>Web Notification</mat-label>
      </div>

      <div class="mt-top-2" *ngIf="pageType !== 'alertProfile'">
        <!-- <mat-form-field class="field">
                    <mat-label>Push Notification</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="pushNotification">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field> -->

        <mat-slide-toggle formControlName="pushNotification" (change)="pushNotificationChange($event)">
        </mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>Push Notification</mat-label>
      </div>
      <div class="mt-top-2">
        <!-- <mat-form-field class="field">
                    <mat-label>Auto Close</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="autoClose">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field> -->

        <mat-slide-toggle formControlName="autoClose" (change)="autoCloseChange($event)"></mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>Auto Close</mat-label>
      </div>
    </div>
    <div class="make-responsive alert-field" *ngIf="alertValue && pageType !== 'alertProfile'">
      <div class="mt-top-2 field">
        <mat-slide-toggle formControlName="allowDuplicates">
        </mat-slide-toggle>
        <span class="slider round"></span>
        <mat-label>Allow Duplicate</mat-label>
      </div>
    </div>
    <div class="make-responsive alert-field" *ngIf="alertValue && pageType !== 'alertProfile'">
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>MType</mat-label>
          <input matInput type="number" formControlName="mtype">
          <ng-container *ngIf="formSubmitted && formValues['mtype'].errors">
            <mat-error *ngIf="formValues['mtype'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>MType is required
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field">
        <mat-form-field class="field">
          <mat-label>Message</mat-label>
          <input matInput formControlName="message">
          <ng-container *ngIf="formSubmitted && formValues['message'].errors">
            <mat-error *ngIf="formValues['message'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Message is required
            </mat-error>
            <mat-error *ngIf="formValues['message'].errors?.['pattern']">
              <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="autoCloseTrigger">
        <mat-form-field class="field">
          <mat-label>Trigger Delay</mat-label>
          <input matInput type="number" formControlName="triggerDelay">
          <ng-container *ngIf="formSubmitted && formValues['triggerDelay'].errors">
            <mat-error *ngIf="formValues['triggerDelay'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Trigger Delay is required
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="autoCloseTrigger">
        <mat-form-field class="field">
          <mat-label>Delay Alert Duration</mat-label>
          <input matInput type="number" formControlName="delayAlertDuration">
          <ng-container *ngIf="formSubmitted && formValues['delayAlertDuration'].errors">
            <mat-error *ngIf="formValues['delayAlertDuration'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Delay Alert is required
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field -mat-select-arrow-mt-22">
        <mat-form-field class="field">
          <mat-label>UOM</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="uom">
            <mat-option *ngFor="let item of uom; let i = index" [value]="item" selected>
              {{item | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-top-2 field" *ngIf="formValues['allowDuplicates']?.value">
        <mat-form-field class="field">
          <mat-label>{{ formLabelName }}</mat-label>
          <input matInput type="number" formControlName="duplicateDuration">
          <ng-container *ngIf="formSubmitted && formValues['duplicateDuration'].errors">
            <mat-error *ngIf="formValues['duplicateDuration'].errors?.['required']">
              <em class="fas fa-exclamation-circle mr-2"></em>Duplicate Duration is required
            </mat-error>
          </ng-container>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
          class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
    </div>
    <div class="btn-basket">
      <button mat-raised-button color="primary" data-dismiss="modal" type="button" (click)="closeModal()">Close</button>
      <button mat-raised-button color="primary" type="submit" *ngIf="this.alertRuleAdd || this.alertRuleEdit">
        {{ alertRuleEdit ? 'Update' : 'Submit' }}
      </button>
    </div>
  </form>
</div>